(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  document.addEventListener('click', function(event) {
    const link = event.target.closest('[data-wdlt-empty-clear]');
    if (!link || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    const url = new URL(location.href);
    [...url.searchParams.keys()].filter(key => key.startsWith('filter.') || key === 'page' || key === 'wdlt_page').forEach(key => url.searchParams.delete(key));
    location.assign(url);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;

  $('.recommendations_slide').slick({
  	dots: false,
    slidesToShow: 6,
	prevArrow:"<button type='button' class='slick-prev'><i class='fa fa-angle-left' aria-hidden='true'></i></button>", 
  	nextArrow:"<button type='button' class='slick-next'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
  });
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wdlt-appointment"] && !Shopify.designMode) return;
  try {
    
(()=>{
const root=document.querySelector('.wdlt-appointment');if(!root)return;
const form=root.querySelector('#ContactForm'),q=id=>root.querySelector('#'+id);
const success=q('ap-success');if(success){const reveal=()=>requestAnimationFrame(()=>{success.focus({preventScroll:true});success.scrollIntoView({behavior:'instant',block:'center'})});if(document.readyState==='complete')reveal();else window.addEventListener('load',reveal,{once:true});form.addEventListener('submit',e=>e.preventDefault());}
const purpose=q('ap-purpose-value'),purposeToggle=q('ap-purpose-toggle'),list=q('ap-purpose-list'),date=q('ap-date-value'),dateToggle=q('ap-date-toggle'),calendar=q('ap-calendar'),time=q('ap-time'),error=q('ap-error');
const toronto=()=>Object.fromEntries(new Intl.DateTimeFormat('en-CA',{timeZone:'America/Toronto',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(new Date()).map(p=>[p.type,p.value]));
const iso=(y,m,d)=>y+'-'+String(m+1).padStart(2,'0')+'-'+String(d).padStart(2,'0');
const today=()=>{const n=toronto();return n.year+'-'+n.month+'-'+n.day};
const now=toronto();let year=+now.year,month=+now.month-1;
const slots=value=>{const n=toronto(),m=Number(value.slice(5,7)),last=m<=3?17*60:18*60,result=[];for(let t=720;t<=last;t+=30){if(value===today()&&t<=Number(n.hour)*60+Number(n.minute))continue;result.push((Math.floor(t/60)===12?12:Math.floor(t/60)-12)+':'+String(t%60).padStart(2,'0')+' PM')}return result};
const setOpen=(panel,toggle,open)=>{panel.hidden=!open;toggle.setAttribute('aria-expanded',String(open))};
const close=()=>{setOpen(list,purposeToggle,false);setOpen(calendar,dateToggle,false)};
purposeToggle.addEventListener('click',()=>{const open=list.hidden;close();setOpen(list,purposeToggle,open);if(open)list.querySelector('button').focus()});
list.addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;purpose.value=b.textContent;q('ap-purpose-text').textContent=b.textContent;list.querySelectorAll('button').forEach(o=>o.setAttribute('aria-selected',String(o===b)));close();purposeToggle.focus();error.hidden=true});
list.addEventListener('keydown',e=>{const opts=[...list.querySelectorAll('button')],i=opts.indexOf(document.activeElement);if(['ArrowDown','ArrowUp','Home','End'].includes(e.key)){e.preventDefault();const next=e.key==='Home'?0:e.key==='End'?opts.length-1:(i+(e.key==='ArrowDown'?1:-1)+opts.length)%opts.length;opts[next].focus()}});
function render(){q('ap-month').textContent=new Intl.DateTimeFormat('en-CA',{month:'long',year:'numeric',timeZone:'UTC'}).format(new Date(Date.UTC(year,month,1)));const days=q('ap-days');days.replaceChildren();const first=new Date(Date.UTC(year,month,1)).getUTCDay(),total=new Date(Date.UTC(year,month+1,0)).getUTCDate();for(let i=0;i<first;i++)days.append(document.createElement('span'));for(let d=1;d<=total;d++){const value=iso(year,month,d),b=document.createElement('button');b.type='button';b.textContent=d;b.dataset.date=value;b.setAttribute('aria-label',new Intl.DateTimeFormat('en-CA',{dateStyle:'full',timeZone:'UTC'}).format(new Date(value+'T12:00:00Z')));b.setAttribute('aria-pressed',String(value===date.value));b.disabled=value<today()||new Date(value+'T12:00:00Z').getUTCDay()===0||slots(value).length===0;days.append(b)}const n=toronto();q('ap-prev').disabled=year===+n.year&&month===+n.month-1}
dateToggle.addEventListener('click',()=>{const open=calendar.hidden;close();render();setOpen(calendar,dateToggle,open)});
q('ap-prev').addEventListener('click',()=>{month--;if(month<0){month=11;year--}render()});q('ap-next').addEventListener('click',()=>{month++;if(month>11){month=0;year++}render()});
q('ap-days').addEventListener('click',e=>{const b=e.target.closest('button[data-date]');if(!b||b.disabled)return;date.value=b.dataset.date;q('ap-date-text').textContent=new Intl.DateTimeFormat('en-CA',{month:'long',day:'numeric',year:'numeric',timeZone:'UTC'}).format(new Date(date.value+'T12:00:00Z'));time.replaceChildren(new Option('Select a time',''));slots(date.value).forEach(t=>time.add(new Option(t,t)));time.disabled=false;close();dateToggle.focus();error.hidden=true});
root.addEventListener('keydown',e=>{if(e.key==='Escape'){const target=!list.hidden?purposeToggle:dateToggle;close();target.focus()}});
document.addEventListener('click',e=>{if(!e.target.closest('.ap-purpose')&&!e.target.closest('.ap-date-wrap'))close()});
form.addEventListener('submit',e=>{let message='',target;if(!purpose.value){message='Please select an appointment purpose.';target=purposeToggle}else if(!date.value||date.value<today()||new Date(date.value+'T12:00:00Z').getUTCDay()===0){message='Please choose an available date.';target=dateToggle}else if(!slots(date.value).includes(time.value)){message='Please select an available time.';target=time}if(message){e.preventDefault();error.textContent=message;error.hidden=false;target.focus()}},true);
})();

  } catch(e) { console.error(e); }
})();
})();
